module.exports = __webpack_public_path__ + "images/c26a432bcffca47b1598c2104aad66c0c50299f55a05c1323eaab513c6b9f69f.svg";